<template>
  <v-app>
    <router-view>
      <slot></slot>
    </router-view>
    <!-- Notification widget -->
    <notifications
      group="status"
      animation-type="velocity"
      position="bottom right"
      :duration="5000"
    />
    <!-- Ask dialog -->
    <vue-confirm-dialog class="delete-consultified-dialog"></vue-confirm-dialog>
    <!-- End of dialog -->
  </v-app>
</template>
<script>
export default {
  components: {},
  mounted() {
    let vm = this;
    window.addEventListener(
      "message",
      (event) => {
        const message = event.data.message;
        switch (message) {
          case "crmPathNavigate":
            if (vm.$route.path != event.data.value) {
              vm.$router.push({ path: event.data.value });
            }
            break;
        }
      },
      false
    );
  },
  data: () => ({}),
  watch: {},
};
</script>

<style lang="scss">
@font-face {
  font-family: "Amblas";
  src: url("assets/fonts/Amblas.ttf");
}
@font-face {
  font-family: "Avenir";
  src: url("assets/fonts/AvenirLTStd-Book.ttf");
}
@font-face {
  font-family: "AvenirBlack";
  src: url("assets/fonts/avenir/AvenirLTStd-Black.otf") format("opentype");
}

@font-face {
  font-family: "AvenirBook";
  src: url("assets/fonts/avenir/AvenirLTStd-Book.otf") format("opentype");
}

@font-face {
  font-family: "AvenirRoman";
  src: url("assets/fonts/avenir/AvenirLTStd-Roman.otf") format("opentype");
}
@import "~@/styles/style.scss";
* {
  box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  font-family: Avenir;
  font-weight: normal;
  font-size: 13px;
}

.project-item-body {
  .project-info {
    p {
      margin-bottom: 3px;
    }
    p.disc {
      margin-bottom: 8px;
    }
    ul {
      padding-left: 8px;
    }
    ul > li {
      list-style-type: none;
    }
    ul > li::before {
      content: "\2022";
      margin-right: 5px;
    }
  }
}
.employment-item-body {
  .employment-info {
    p {
      margin-bottom: 3px;
    }
    p.disc {
      margin-bottom: 8px;
    }
    ul {
      padding-left: 8px;
    }
    ul > li {
      list-style-type: none;
    }
    ul > li::before {
      content: "\2022";
      margin-right: 5px;
    }
  }
}
.delete-consultified-dialog {
  .vc-container {
    width: 486px;
    border-radius: 5px;
    padding: 25px 0px;
    .vc-title {
    }
    .vc-text {
      padding-top: 10px;
    }
    .vc-btn-grid {
      padding: 10px 60px;
      grid-column-gap: 40px;
      .vc-btn {
        border: none;
        min-height: 40px !important;
        border-radius: 5px;
        &.left {
          background: #620000;
          color: #fff;
        }
        &:nth-child(2) {
          color: #808080;
        }
      }
    }
  }
}
button {
  cursor: pointer;
  outline: none;
  border: none;
  background: transparent;
}
input[type="text"] {
  cursor: pointer;
  outline: none;
  border: none;
  height: 25px;
}
input[type="button"] {
  cursor: pointer;
  outline: none;
  border: none;
}
.pac-container {
  z-index: 99999999999999999 !important;
}
.vue-notification-group {
  z-index: 99999999999999999 !important;
}
.notification-title {
  font-size: 17px !important;
  border-bottom: 1px solid rgb(247, 202, 134);
  padding-bottom: 4px;
}

.notification-content {
  font-size: 14px !important;
  padding: 10px 0px;
}
.__bar-wrap-is-vertical {
  border-radius: 5px !important;
  opacity: 0.3;
  transition: 300ms ease-in-out;
  &:hover {
    opacity: 1;
    transition: 300ms ease-in-out;
  }
}
.__bar-wrap-is-horizontal {
  border-radius: 5px !important;
  opacity: 0.3;
  transition: 300ms ease-in-out;
  &:hover {
    opacity: 1;
    transition: 300ms ease-in-out;
  }
}
.story_body {
  .__vuescroll {
    &:hover {
      .__bar-wrap-is-vertical {
        opacity: 1;
        transition: 300ms ease-in-out;
      }
      .__bar-wrap-is-horizontal {
        opacity: 1;
        transition: 300ms ease-in-out;
      }
    }
  }
}
</style>
<style lang="scss">
</style>